const SVG_NS = 'http://www.w3.org/2000/svg';

/**
 * Icons are built as real SVG nodes rather than an inline `<img src="data:...">` or a
 * background image: `el()` can't make them (createElement puts everything in the HTML
 * namespace, and an `<svg>` built that way renders as nothing), and both alternatives
 * would need a colour baked in at build time instead of following `currentColor`.
 *
 * Always `aria-hidden`. Every icon here sits next to its own label, so announcing it
 * would only repeat the text beside it.
 */
function icon(...paths: Array<{ tag: 'path' | 'circle'; attrs: Record<string, string> }>) {
  const svg = document.createElementNS(SVG_NS, 'svg');
  for (const [key, value] of Object.entries({
    class: 'icon',
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    'stroke-width': '2',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'aria-hidden': 'true',
    focusable: 'false',
  })) {
    svg.setAttribute(key, value);
  }

  for (const { tag, attrs } of paths) {
    const node = document.createElementNS(SVG_NS, tag);
    for (const [key, value] of Object.entries(attrs)) node.setAttribute(key, value);
    svg.append(node);
  }

  return svg;
}

/** A map pin, for anything that names where the search is centred. */
export function pinIcon(): SVGElement {
  return icon(
    { tag: 'path', attrs: { d: 'M12 21s7-5.5 7-11a7 7 0 1 0-14 0c0 5.5 7 11 7 11z' } },
    { tag: 'circle', attrs: { cx: '12', cy: '10', r: '2.5' } },
  );
}
